// eslint-disable-next-line import/no-extraneous-dependencies
import events from 'events/events.js';

// 全局事件分发器
// eslint-disable-next-line import/prefer-default-export
export const emitter = new events.EventEmitter();

emitter.setMaxListeners(0);
